import { Component } from '@angular/core';

@Component({
  selector: 'graph',
  template: `<ng-content></ng-content>`,
  styles: [`
    :host {
      display: block;
      width: 100%;
      height: 100%;
    }
  `]
})
export class GraphComponent {

}

export abstract class Graph {
  resize() {
  }
}
